export default __webpack_public_path__ + "static/media/fair_dist.68da3595.png";